module.exports = __webpack_public_path__ + "img/bg01.df051bae.png";